<template>
  <div
    class="d-flex col justify-content-lg-start justify-content-md-start justify-content-center mb-2 mb-lg-0 mb-sm-0 mb-md-0"
  >
    <div class="dataperpage me-2">
      <p>
        <i class="fas fa-eye me-2"></i>Perhalaman :
        {{ perPage }}
      </p>
    </div>
    <div class="dataperpage me-2">
      <p>
        <i class="fas fa-eye me-2"></i>Page :
        {{ currentPage }}
      </p>
    </div>
    <div class="totaldata">
      <p><i class="fas fa-database me-2"></i>{{ totalItems }}</p>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    perPage: {
      type: Number,
      required: true,
      default: 0,
    },
    currentPage: {
      type: Number,
      required: true,
      default: 0,
    },
    totalItems: {
      type: Number,
      required: true,
      default: 0,
    },
  },
};
</script>
<style scoped>
/* SHOW PERPAGE & TOTAL DATA */
.dataperpage p,
.totaldata p {
  font-size: 12px;
  padding: 5px 8px !important;
  border-radius: 3px;
  border: 1px solid var(--border-one);
}
</style>
